var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#9BA2B6",
        height: "23",
        viewBox: "0 0 23 23",
        width: "23",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M4.492 5.076c0-.496.402-.898.899-.898h12.218a.898.898 0 1 1 0 1.797H5.391a.898.898 0 0 1-.899-.899zM18.508 8.67a.898.898 0 0 0-.899-.899H5.391a.898.898 0 1 0 0 1.797h12.218a.898.898 0 0 0 .899-.898zM5.39 11.365a.898.898 0 1 0 0 1.797h4.132a.898.898 0 1 0 0-1.797H5.391zM22.21 18.4a2.698 2.698 0 0 1 0 3.81 2.687 2.687 0 0 1-1.906.789c-.69 0-1.38-.263-1.906-.788l-4.913-4.923a.897.897 0 0 1-.23-.395l-1.005-3.626a.899.899 0 0 1 1.127-1.1l3.537 1.075c.141.043.27.12.375.225L22.21 18.4zm-7.287-2.214l3.303 3.309 1.27-1.271-3.32-3.328-1.758-.534.505 1.824zm6.016 3.483l-.173-.173-1.27 1.27.173.175a.9.9 0 0 0 1.27-1.272zM19.406 0H3.594A3.598 3.598 0 0 0 0 3.594v15.812A3.598 3.598 0 0 0 3.594 23H14.6a.898.898 0 1 0 0-1.797H3.594c-.991 0-1.797-.806-1.797-1.797V3.594c0-.991.806-1.797 1.797-1.797h15.812c.991 0 1.797.806 1.797 1.797v11.05a.898.898 0 1 0 1.797 0V3.595A3.598 3.598 0 0 0 19.406 0z",
          "fill-rule": "nonzero",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }